// @flow
import { Record } from 'immutable';
import SalesPromotion from 'common/modules/sales/domain/SalesPromotion';
import {
  FETCH_PROMOTIONS,
  FETCH_PROMOTIONS_SUCCESS,
  FETCH_PROMOTIONS_FAILED,
  ACCEPT_PROMOTION,
  ACCEPT_PROMOTION_SUCCESS,
  ACCEPT_PROMOTION_FAILED,
  DECLINE_PROMOTION,
  DECLINE_PROMOTION_SUCCESS,
  DECLINE_PROMOTION_FAILED,
} from '../actions/promotionActions';

export type PromotionState = {
  promotions: SalesPromotion[];
  fetching: boolean;
  error: ?Object;
  propositionStateModificationError: ?Object;
  accepting: boolean;
  declining: boolean;
};

export const InitialState = Record({
  promotions: [],
  fetching: false,
  error: undefined,
  accepting: false,
  declining: false,
});

const replace = (array: SalesPromotion[], value: SalesPromotion) => {
  const filteredArray = array.filter(p => !p.isSame(value));
  filteredArray.push(value);

  return filteredArray;
};

export default (state: Record<PromotionState> = new InitialState(), action: Object) => {
  switch (action.type) {
    case FETCH_PROMOTIONS:
      return state.set('promotions', [])
                  .set('fetching', true)
                  .set('error', undefined);
    case FETCH_PROMOTIONS_SUCCESS:
      return state.set('fetching', false)
                  .set('promotions', action.promotions);
    case FETCH_PROMOTIONS_FAILED:
      return state.set('fetching', false)
                  .set('error', action.error);
    case ACCEPT_PROMOTION:
      return state.set('accepting', true);
    case ACCEPT_PROMOTION_SUCCESS: {
      const promotions = replace(state.get('promotions'), action.promotion);

      return state.set('promotions', promotions)
                  .set('accepting', false);
    }
    case ACCEPT_PROMOTION_FAILED:
      return state.set('accepting', false);
    case DECLINE_PROMOTION:
      return state.set('declining', true);
    case DECLINE_PROMOTION_SUCCESS: {
      const promotions = replace(state.get('promotions'), action.promotion);

      return state.set('promotions', promotions)
                  .set('declining', false);
    }
    case DECLINE_PROMOTION_FAILED:
      return state.set('declining', false);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/reducers/promotionReducer.js